export function initialData(
  state = {
    users: [],
    projectUsages: [],
    demandDashboardData: [],
  },
  action
) {
  switch (action.type) {
    case 'GET_DEMAND_DASHBOARD_DATA_START':
      return {
        ...state,
        users: [],
        projectUsages: [],
        demandDashboardData: [],
      };

    case 'GET_DEMAND_DASHBOARD_DATA_DONE':
      return {
        ...state,
        demandDashboardData: action.demandDashboardData,
      };
    case 'GET_INIT_DATA_START':
      return {
        ...state,
        users: [],
        projectUsages: [],
        demandDashboardData: [],
      };
    case 'GET_INIT_DATA_DONE':
      return {
        ...state,
        users: action.users,
        projectUsages: action.projectUsages,
      };
    case 'ADD_DEMAND_DASHBOARD_PROJECT':
      return {
        ...state,
        demandDashboardData: state.demandDashboardData.map(demand => {
          if (demand.key === 'numberOfProjects') {
            demand.count++;
          }
          return demand;
        }),
      };
    default:
      return state;
  }
}
